/**
 * Grupo acordeón exclusivo: al abrir un <details>, cierra los demás del mismo contenedor.
 * Usado en PDP FAQ para mantener una sola respuesta abierta (mejor UX móvil).
 */
class ExclusiveAccordionGroup extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('toggle', this.#onToggle, { signal, capture: true });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /** @param {Event} event */
  #onToggle = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLDetailsElement)) return;
    if (!target.open) return;
    if (!this.contains(target)) return;

    for (const details of this.querySelectorAll('details')) {
      if (details !== target) {
        details.open = false;
      }
    }
  };
}

if (!customElements.get('exclusive-accordion-group')) {
  customElements.define('exclusive-accordion-group', ExclusiveAccordionGroup);
}
